<div class="topline">
  <div class="dialog-heading">
    <h1 mat-dialog-title>
      {{user ? 'Modify Existing User' : 'Add New User'}}
    </h1>
    @if (user) {
      <div class="user-summary">
        <div class="user-summary-name-email">{{user.firstName}} {{user.lastName}} ({{user.email}})</div>
        <div class="user-summary-id">User ID: {{user.id}}</div>
      </div>
    }
  </div>
  <button mat-fab (click)="playHelpMovie()"><mat-icon>movie</mat-icon></button>
</div>
<div mat-dialog-content>
  @if (canViewProducts) {
    <app-user-products [userId]="user.id"></app-user-products>
  }
  <form class="form" [formGroup]="form" autocomplete="off">
    <mat-form-field class="rightspacer">
      <mat-label>Partner</mat-label>
      <mat-select formControlName="partner">
        @for (partner of partners; track partner) {
          <mat-option [value]="partner.partnerId">{{partner.name}}</mat-option>
        }
      </mat-select>
    </mat-form-field>
    @if (user) {
      <section class="company-associations" aria-labelledby="company-associations-heading">
        <h2 id="company-associations-heading">Company associations</h2>
        @if (companyAssociationsLoadState === 'loading') {
          <p role="status">{{companyAssociationsCopy.loading}}</p>
        }
        @if (companyAssociationsLoadState === 'error') {
          <p class="company-associations-error" role="alert">
            {{companyAssociationsCopy.error}}
          </p>
        }
        @if (companyAssociationsLoadState === 'loaded' && companyAssociations.length === 0) {
          <p>
            {{companyAssociationsCopy.empty}}
          </p>
        }
        @if (companyAssociationsLoadState === 'loaded' && companyAssociations.length > 0) {
          <div class="company-associations-table-wrapper">
            <table class="company-associations-table">
              <thead>
                <tr>
                  <th scope="col">Company</th>
                  <th scope="col">Direct roles</th>
                  <th scope="col">Team associations</th>
                </tr>
              </thead>
              <tbody>
                @for (association of companyAssociations; track trackCompanyAssociation($index, association)) {
                  <tr>
                    <th scope="row">{{association.companyName}}</th>
                    <td>
                      @if (association.directRoles.length > 0) {
                        <ul>
                          @for (role of association.directRoles; track role) {
                            <li>{{role}}</li>
                          }
                        </ul>
                      }
                      @if (association.directRoles.length === 0) {
                        <span>{{companyAssociationsCopy.noDirectRoles}}</span>
                      }
                    </td>
                    <td>
                      @if (association.teamAssociations.length > 0) {
                        <ul>
                          @for (team of association.teamAssociations; track team) {
                            <li>{{team.teamName}}</li>
                          }
                        </ul>
                      }
                      @if (association.teamAssociations.length === 0) {
                        <span>{{companyAssociationsCopy.noTeamAssociations}}</span>
                      }
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        }
      </section>
    }
    <mat-form-field>
      <mat-label>Receive Offers</mat-label>
      <mat-select formControlName="receiveOffers">
        <mat-option [value]="1">Yes</mat-option>
        <mat-option [value]="0">No</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field hintLabel="Max 50 characters">
      <mat-label>First Name</mat-label>
      <input matInput #input maxlength="50" placeholder="" formControlName="firstname">
      <mat-hint align="end">{{input.value.length || 0}}/50</mat-hint>
    </mat-form-field>
    <mat-form-field hintLabel="Max 50 characters">
      <mat-label>Last Name</mat-label>
      <input matInput #input2 maxlength="50" placeholder="" formControlName="lastname">
      <mat-hint align="end">{{input2.value.length || 0}}/50</mat-hint>
    </mat-form-field>
    <mat-form-field hintLabel="me@example.com">
      <mat-label>Email</mat-label>
      <input matInput #input3  placeholder="" formControlName="email" [readonly]="!!user">
      @if (!emailVerified && !user) {
        <button type="button" matSuffix class="verifybutton" [disabled]="true" mat-raised-button>Save Before Verifying</button>
      }
      @if (emailVerified && user) {
        <button type="button" matSuffix class="verifybutton" [disabled]="true" mat-raised-button>Verified</button>
      }
      @if (!emailVerified && user) {
        <button type="button" matSuffix color="accent" class="verifybutton" mat-raised-button [disabled]="isEmailVerificationDisabled()" (click)="forceVerifyEmail()">Force Verify</button>
      }
      @if (!emailVerified && user) {
        <button type="button" matSuffix color="accent" class="verifybutton" mat-raised-button [disabled]="isEmailVerificationDisabled()" (click)="verifyEmail()">User Verify</button>
      }
    </mat-form-field>
    <mat-form-field hintLabel="personal@example.com">
      <mat-label>Backup Email</mat-label>
      <input matInput type="email" placeholder="" formControlName="alternateEmail">
      @if (form.get('alternateEmail')?.hasError('email')) {
        <mat-error>Enter a valid email address</mat-error>
      }
    </mat-form-field>
    @if (user?.verificationCode) {
      <mat-form-field>
        <mat-label>Email Last Code Sent</mat-label>
        <input matInput [value]="user.verificationCode" readonly>
      </mat-form-field>
    }
    <mat-form-field>
      <mat-label>Mobile Number</mat-label>
      <input matInput maxlength="10" minLength="10" placeholder="" formControlName="tel" type="tel">
      @if (!phoneVerified && !user) {
        <button type="button" matSuffix class="verifybutton" [disabled]="true" mat-raised-button>Save Before Verifying</button>
      }
      @if (phoneVerified && user) {
        <button type="button" matSuffix class="verifybutton" [disabled]="true" mat-raised-button>Verified</button>
      }
      @if (!phoneVerified && user) {
        <button type="button" matSuffix color="accent" class="verifybutton" mat-raised-button [disabled]="phoneVerified || !!form.get('tel')?.errors || form.get('tel')?.value?.length < 3" (click)="forceVerifyPhoneNumber()">Force Verify</button>
      }
      @if (!phoneVerified && user) {
        <button type="button" matSuffix color="accent" class="verifybutton" mat-raised-button [disabled]="phoneVerified || !!form.get('tel')?.errors || form.get('tel')?.value?.length < 3" (click)="verifyPhoneNumber()">User Verify</button>
      }
    </mat-form-field>
    @if (user?.lastCode) {
      <mat-form-field>
        <mat-label>Phone Last Code Sent</mat-label>
        <input matInput [value]="user.lastCode" readonly>
      </mat-form-field>
    }
    <mat-form-field>
      <mat-label>Date of Birth</mat-label>
      <input matInput [matDatepicker]="picker" [max]="maxDate" formControlName="dob">
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>
    <mat-form-field>
      <mat-label>Address 1</mat-label>
      <input matInput placeholder="" formControlName="address1">
    </mat-form-field>
    <mat-form-field>
      <mat-label>Address 2</mat-label>
      <input matInput placeholder="" formControlName="address2">
    </mat-form-field>
    <mat-form-field>
      <mat-label>City</mat-label>
      <input matInput placeholder="" formControlName="city">
    </mat-form-field>
    <mat-form-field>
      <mat-label>State</mat-label>
      <app-state formControlName="state"></app-state>
    </mat-form-field>
    <mat-form-field>
      <mat-label>Zip Code</mat-label>
      <input matInput placeholder="" formControlName="postalCode" name="memberPostalCode" autocomplete="postal-code" inputmode="numeric">
      <mat-error>Enter a five-digit ZIP code or ZIP+4.</mat-error>
    </mat-form-field>
    <mat-form-field>
      <mat-label>SSN</mat-label>
      @if (editingSsn) {
            <input matInput type="text" formControlName="ssn" name="memberSsn" autocomplete="off" inputmode="numeric" maxlength="9" aria-label="SSN, nine digits">
          } @else {
            <input matInput type="text" readonly [value]="hideSsn && form.get('ssn')?.value ? '••• •• ••••' : form.get('ssn')?.value" aria-label="SSN" autocomplete="off">
          }
          @if (!editingSsn) {
            <button mat-button matSuffix type="button" (click)="editingSsn = true; hideSsn = true">Edit</button>
          }
          @if (!editingSsn && form.get('ssn')?.value) {
            <button mat-button matSuffix type="button" (click)="hideSsn = !hideSsn">{{hideSsn ? 'Show' : 'Hide'}}</button>
          }
          <mat-error>Enter exactly nine digits.</mat-error>
    </mat-form-field>
  </form>
  <div class="buttons" mat-dialog-actions>
    <button mat-raised-button color="primary" class="primarybutton" shape="" [disabled]="saving || form.invalid || form.pending" (click)="saveClicked($event)">{{saving ? 'Saving...' : 'Save'}}</button>
    <button mat-raised-button (click)="onDismiss()">Cancel</button>
  </div>
</div>
